module.exports = __webpack_public_path__ + "static/media/design-glide.252723e6.png";